import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const usePageTitle = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("landing.title");
  }, [t]);
};
